<template>
  <div class="data-view-detail-container">
    <div
      v-show="showOperate"
      class="condition"
    >
      <span
        v-for="(item, index) in btnArr"
        :key="index"
        v-show="handleShow(item)"
        @click="handleCommand(item.id)"
      >
        <i :class="['icon', item.icon]" />{{ item.label }}
      </span>
    </div>
    <div
      class="detail-container"
      v-show="!isEmpty"
    >
      <h5
        v-html="formatTitle(documentInfo.title)"
        class="title"
      />
      <h6 class="pubdate">
        <span>{{ labelDate }}：{{ pubdate }}</span>
        <div v-if="this.isInternetData">
          {{ documentInfo.source }}
        </div>
        <span v-else>录入单位：{{ documentInfo.department }}</span>
      </h6>
      <div
        class="orginal-box file-container"
        v-if="isVideo || isAudio"
      >
        <div
          v-for="(item, index) in documentInfo.attachments"
          :key="index"
          class="orginal-box_item"
        >
          <video
            v-if="isVideo"
            :src="item.b_uri"
            controls
          />
          <audio
            v-else
            :src="item.b_uri"
            controls
          />
          <div class="orginal-box_item-intro">
            <h6 :title="item.name">
              {{ item.name }}
            </h6>
            <router-link
              target="_blank"
              class="toDetail"
              :to="
                `/jgsd/video?modelId=${currentIndex}&id=${item.id}&docId=${documentInfo.id}&isAlter=${isCanAlter}`
              "
            >
              查看详情
            </router-link>
          </div>
        </div>
      </div>
      <div
        v-else-if="isImgsArr && documentInfo.attachments.length !== 0"
        class="imgs-list"
      >
        <el-carousel
          :autoplay="false"
          arrow="always"
          indicator-position="none"
          @change="
            index => {
              this.currentImgIndex = index;
            }
          "
        >
          <el-carousel-item
            v-for="(item, index) in imgArrAttachments"
            :key="index"
          >
            <el-image
              :src="item.b_uri"
              fit="cover"
              @click="seeOriImg(index)"
            >
              <div
                slot="error"
                class="image-slot"
              >
                <img :src="require('@assets/imgs/jlxk/image-error.png')">
                <h6>图片加载中......</h6>
              </div>
            </el-image>
            <h3 class="indicator">
              {{ index + 1 }}/{{ imgArrAttachments.length }}
            </h3>
          </el-carousel-item>
        </el-carousel>
        <router-link
          v-if="isShowAIPic"
          target="_blank"
          class="toDetail"
          :to="
            `/jgsd/image?modelId=${currentIndex}&index=${currentImgIndex}&docId=${documentInfo.id}&articleTypeId=2&isAlter=${isCanAlter}`
          "
        >
          查看详情
        </router-link>
      </div>
      <div
        class="bookFile-list file-container"
        v-if="isBookFile"
      >
        <div class="hd">
          <span>书籍名称</span>
          <span>出版单位</span>
          <span>操作</span>
        </div>
        <ul class="bd">
          <li
            v-for="(item, index) in bookFile"
            :key="index"
          >
            <span
              :title="item.name"
            ><i
              :class="[
                'icon',
                `jlxk-detail-${
                  item.name.indexOf('.pdf') !== -1 ? 'pdf' : 'zip'
                }`
              ]"
            />{{ item.name }}</span>
            <span>{{ documentInfo.publisher }}</span>
            <span>
              <el-button @click="downLoad(item)">下载</el-button>
            </span>
          </li>
        </ul>
      </div>
      <h6
        v-show="!isImgText"
        class="intro-title"
      >
        内容简介：
      </h6>
      <div
        :class="[
          'content',
          { content_intro: !isImgText, content_internet: this.isInternetData }
        ]"
        v-html="documentInfo.content"
      />
      <!-- 短视频展示封面图 -->
      <div
        v-if="isShowVideoCover"
        class="video-cover"
      >
        <el-image
          v-if="isSupportReferrerpolicy"
          :src="documentInfo.coverPicUrl"
          referrerpolicy="no-referrer"
          @click="handleOnPreview('videoImageViewer', 0)"
          fit="cover"
        >
          <div
            slot="error"
            class="image-slot"
          >
            <img :src="loadError">
          </div>
        </el-image>
        <div
          v-else
          v-html="
            iframeImgDetailPage(
              documentInfo.coverPicUrl,
              'width: 100%;',
              'width: auto;margin: 10px auto;vertical-align: top;max-width: 100%;overflow: hidden;display: block;'
            )
          "
        />
        <ImageViewer
          :img-list="[documentInfo.coverPicUrl]"
          ref="videoImageViewer"
        />
      </div>
      <div
        v-if="documentInfo.originalPicUrl"
        class="img-container"
      >
        <div
          class="img-container_item"
          v-for="(imgUrl, imgIndex) in imgList"
          :key="imgIndex"
        >
          <el-image
            v-if="isSupportReferrerpolicy"
            :src="imgUrl"
            referrerpolicy="no-referrer"
            fit="cover"
            @click="handleOnPreview('detailImageViewer', imgIndex)"
          >
            <div
              slot="error"
              class="image-slot"
            >
              <img :src="loadError">
            </div>
          </el-image>
          <div
            v-else
            v-html="iframeImg(imgUrl, 150, 100, 0)"
          />
        </div>
        <ImageViewer
          :img-list="imgList"
          ref="detailImageViewer"
        />
      </div>
    </div>
    <div
      class="emtpy"
      v-show="isEmpty"
    >
      当前未查询到任何数据
    </div>
    <ImageViewer
      :img-list="allImgList"
      ref="allImageViewer"
    />
    <ImageViewer
      :img-list="imgArrView"
      ref="imageArrViewer"
      v-if="isImgsArr"
    />
  </div>
</template>

<script>
import ImageViewer from '@components/detail/ImageViewer.vue'
import APIS from '@apis/jlxk.js'
window.iframeImgs = []
window.iframesIndex = 0
export default {
  name: 'NewsDetail',
  props: {
    currentItem: {
      type: Object,
      default: () => {}
    },
    btnArr: {
      type: Array,
      default: () => [
        {
          id: 'alter',
          label: '修改',
          icon: 'jlxk-data-view-alter'
        }
      ]
    },
    isShowOperate: {
      type: Boolean,
      default: false
    },
    highLightKeywordsId: {
      type: String,
      default: ''
    },
    isCanAlterDetail: {
      type: Boolean,
      default: true
    },
    isNeedAjax: {
      type: Boolean,
      default: true
    }
  },
  components: {
    ImageViewer
  },
  data() {
    return {
      loadError: require('@assets/imgs/loadError.png'),
      currentImgIndex: 0,
      isSupportReferrerpolicy: true,
      isShowAIPic: auth_ai_pic_enabled,
      documentInfo: {
        id: '',
        status: '',
        oriSystem: 0,
        attachments: [],
        keywords: '',
        title: '',
        created: '',
        pubdate: '',
        articleTypeId: '',
        department: '',
        // author: '无',
        content: '',
        source: '无',
        location: '',
        originalPicUrl: '',
        coverPicUrl: '',
        publisher: '',
        folder: ''
      },
      // 需要做图片防盗链处理的域名地址
      IMG_DOMAIN: [
        // 'cnfanews.com',
        // 'sinaimg.cn',
        // 'inews.gtimg.com',
        // 'qpic.cn'
        // 'newaircloud.com',
        // 'gzcankao.com',
        // 'baidu.com'
        // 'dyhjw.com',
        // 'ctdsb.net'
      ],
      keywords: '',
      allImgList: [],
      channelArr: ['news', 'app', 'wemedia', 'epaper'],
      noChannelArr: ['wechat', 'weibo']
    }
  },
  computed: {
    isImgText() {
      return (
        String(this.documentInfo.articleTypeId) === '1' ||
        String(this.documentInfo.articleTypeId) === '4'
      )
    },
    isImgsArr() {
      return String(this.documentInfo.articleTypeId) === '2'
    },
    isAudio() {
      return String(this.documentInfo.articleTypeId) === '6'
    },
    isVideo() {
      return String(this.documentInfo.articleTypeId) === '5'
    },
    isBookFile() {
      return String(this.documentInfo.articleTypeId) === '3'
    },
    bookFile() {
      if (!this.isBookFile) return []
      let result = this.documentInfo.attachments.map((item, index) => {
        let isPDF = item.name.indexOf('.pdf') !== -1
        return {
          type: isPDF ? 'pdf' : 'zip',
          name: item.name,
          url: `${item.o_uri}`
        }
      })
      return result
    },
    currentIndex() {
      return this.$store.state.currentIndex
    },
    alterURL() {
      return {
        path: '/jgsd/editor',
        query: {
          modelId: this.currentIndex,
          id: this.documentInfo.id
        }
      }
    },
    imgArrAttachments() {
      if (!this.isImgsArr || this.documentInfo.attachments.length === 0) {
        return []
      }
      if (this.documentInfo.coverPicUrl === '') {
        return this.documentInfo.attachments
      }
      let result = [...this.documentInfo.attachments]
      let index = result.findIndex(
        item => item.s_uri === this.documentInfo.coverPicUrl
      )
      if (index === 0) return result
      let cover = result.splice(index, 1)
      result.unshift(cover[0])
      return result
    },
    imgArrView() {
      if (this.imgArrAttachments.length === 0) return []
      return this.imgArrAttachments.map(item => item.b_uri) || []
    },
    isCanAlter() {
      return (
        this.$route.path !== '/jgsd/view' &&
        this.isShowOperate &&
        this.isCanAlterDetail
      )
    },
    isEmpty() {
      return !this.currentItem || JSON.stringify(this.currentItem) === '{}'
    },
    showOperate() {
      return this.isShowOperate && !this.isEmpty && !this.isInternetData
    },
    isInternetData() {
      return this.documentInfo.oriSystem === 1
    },
    labelDate() {
      return !this.isInternetData ? '上传时间' : '发布时间'
    },
    imgList() {
      return this.handleTransImg(
        this.documentInfo.location,
        this.documentInfo.originalPicUrl
      )
    },
    isShowVideoCover() {
      let type = ['douyin', 'video', 'kuaishou', 'miaopai', 'bilibili']
      return this.documentInfo.coverPicUrl && String(this.documentInfo.oriSystem) === '1' && type.indexOf(this.documentInfo.folder) !== -1
    },
    pubdate() {
      return this.isInternetData ? this.documentInfo.pubdate : this.documentInfo.created
    }
  },
  created() {
    this.isSupportReferrerpolicy =
      document.createElement('img').referrerPolicy !== undefined
  },
  updated() {
    // 处理详情dom中的图片，非微博
    this.handleDomImg()
  },
  methods: {
    initParams() {
      this.documentInfo = {
        id: '',
        status: '',
        oriSystem: 0,
        keywords: '',
        title: '',
        created: '',
        pubdate: '',
        articleTypeId: '',
        department: '',
        attachments: [],
        // author: '无',
        content: '',
        source: '无',
        location: '',
        originalPicUrl: '',
        coverPicUrl: '',
        publisher: '',
        folder: ''
      }
    },
    async getSpcialDetail(val) {
      let params = {
        id: val,
        hlwId:
          this.highLightKeywordsId === '' ? undefined : this.highLightKeywordsId
      }
      let { status, data } = await APIS.postSpcialDetail({ data: params })
      if (status === 0 && data) {
        this.handleData(data)
      }
    },
    handleData(data) {
      Object.keys(this.documentInfo).forEach(item => {
        this.documentInfo[item] = data[item] || ''
        if (item === 'status') {
          this.documentInfo.status = data.oristatus
        }
        if (item === 'title') {
          this.documentInfo.title =
              data.folder === 'weibo' ? data.content : data.title
        }
        this.documentInfo.content =
            data.oriSystem === 1
              ? this.formatContent(data.content)
              : data.content
        this.documentInfo.source =
            this.noChannelArr.indexOf(data.folder) !== -1
              ? data.channel
              : this.channelArr.indexOf(data.folder) !== -1
                ? `${data.source}  ${data.channel}`
                : `${data.channel}  ${data.source}`
      })
      this.$nextTick(() => {
        this.allImgList = []
        let imgArr = document.querySelectorAll(
          '.data-view-detail-container .content img'
        )
        imgArr.forEach(item => {
          this.allImgList.push(item.src)
        })
      })
    },
    iframeImg(url, w, h, mr) {
      var frameid = 'frameimg' + Math.random()
      let width = w || 145
      let height = h || 130
      let marginRight = mr === undefined ? 10 : mr // mr有可能为0，所以用undefined判断
      window.iframeImgs[window.iframesIndex] =
        '<img id="img" src=\'' +
        url +
        "' />" +
        "<script>window.onload = function() { document.body.setAttribute(\"style\",\"margin:0\");document.getElementById('img').style.width = '100%';document.getElementById('img').style.height = '100%'; }<" +
        '/script>'
      let iframe =
        '<iframe id="' +
        frameid +
        '" src="javascript:parent.iframeImgs[' +
        window.iframesIndex +
        '];" frameBorder="0" scrolling="no" width="' +
        width +
        'px" style="margin-right: ' +
        marginRight +
        'px;height: ' +
        height +
        'px;"></iframe>'
      window.iframesIndex++
      return iframe
    },
    iframeImgDetailPage(url, iframeStyle, imgStyle) {
      var frameid = 'frameimg' + Math.random()
      window.iframeImgs[window.iframesIndex] =
        '<img id="img" src=\'' +
        url +
        "' />" +
        '<script>window.onload = function() { document.body.setAttribute("style","margin:0");document.getElementById(\'img\').style = \'' +
        imgStyle +
        "';parent.document.getElementById('" +
        frameid +
        "').style.height = document.getElementById('img').height+'px';}<" +
        '/script>'
      let iframe =
        '<iframe id="' +
        frameid +
        '" src="javascript:parent.iframeImgs[' +
        window.iframesIndex +
        '];" frameBorder="0" scrolling="no" style="' +
        iframeStyle +
        '"></iframe>'
      window.iframesIndex++
      return iframe
    },
    formatContent(content) {
      let result = content
        .replace(
          new RegExp(`(\r\n\t)|(\r\n)|(\n)|(<br /><br />)`, 'g'),
          '</div><div>'
        )
        .replace(/\s+/g, ' ')
      // 视频添加结束标签和controls属性
      result = result
        .replace(/< img/g, '<img')
        .replace(/< *video/g, '<video controls')
      return result
    },
    handleTransImg(location, imgStr) {
      let _this = this
      let result = []
      let urls = []
      let flag = false
      if (typeof imgStr !== 'string') {
        return result
      }
      urls = imgStr.split(';')
      if (urls.length === 0) {
        return result
      }
      for (let url of urls) {
        flag = _this.IMG_DOMAIN.some(function(item) {
          return url.indexOf(item) !== -1
        })
        if (flag) {
          url =
            '/api/image?url=' +
            encodeURIComponent(location) +
            '&src=' +
            encodeURIComponent(url)
        }
        result.push(url)
      }
      result.length = Math.min(12, result.length)
      return result
    },
    handleDomImg() {
      let _this = this
      let imgArr = document.querySelectorAll(
        '.data-view-detail-container .content img'
      )
      let i = 0
      let len = imgArr.length
      let flag = false
      for (; i < len; i++) {
        let imgUrl = imgArr[i]
        if (imgUrl) {
          imgUrl.setAttribute('referrerpolicy', 'no-referrer')
          if (this.isShowAIPic) {
            let parent = imgUrl.parentNode
            let detailDom = document.createElement('a')
            let imgBox = document.createElement('div')
            imgBox.setAttribute('class', 'img-container')
            detailDom.setAttribute('class', 'toDetail')
            detailDom.setAttribute('target', '_blank')
            detailDom.setAttribute(
              'href',
              `/jgsd/image?modelId=${this.currentIndex}&articleTypeId=${this.documentInfo.articleTypeId}&docId=${this.documentInfo.id}&isAlter=${this.isCanAlter}`
            )
            detailDom.innerText = '查看详情'
            if (imgUrl.parentNode.className !== 'img-container') {
              imgBox.appendChild(imgUrl)
              imgBox.appendChild(detailDom)
              parent.appendChild(imgBox)
            }
          }
          flag = _this.IMG_DOMAIN.some(function(item) {
            return imgUrl.src.indexOf(item) !== -1
          })
          if (flag) {
            imgUrl.src =
              '/api/image?url=' +
              encodeURIComponent(_this.documentInfo.location) +
              '&src=' +
              encodeURIComponent(imgUrl.src)
          }
          imgUrl.onclick = () => {
            let index = _this.allImgList.findIndex(item => item === imgUrl.src)
            _this.$refs.allImageViewer.showViewer = true
            _this.$nextTick(() => {
              _this.$refs.allImageViewer.$refs.imageViewer.index = index || 0
            })
          }
          if (!this.isSupportReferrerpolicy) {
            let iframeStyle = 'width: 100%;'
            let imgStyle =
              'width: auto;margin: 10px auto;vertical-align: top;max-width: 100%;overflow: hidden;display: block;'
            let iframeImg = this.iframeImgDetailPage(
              imgUrl.src,
              iframeStyle,
              imgStyle
            )
            imgUrl.parentNode.innerHTML = iframeImg
          } else {
            // 是图片重新渲染
            imgUrl.parentNode.replaceChild(imgUrl, imgUrl)
          }
        }
      }
    },
    formatTitle(value) {
      let result = value
      if (this.keywords.length) {
        this.keywords.forEach(item => {
          if (item !== '') {
            result = result.replace(new RegExp(item, 'g'), `<em>${item}</em>`)
          }
        })
      }
      return result
    },
    handleOnPreview(obj, index) {
      this.$refs[obj].showViewer = true
      this.$nextTick(() => {
        this.$refs[obj].$refs.imageViewer.index = index
      })
    },
    seeOriImg(index) {
      this.$refs.imageArrViewer.showViewer = true
      this.$nextTick(() => {
        this.$refs.imageArrViewer.$refs.imageViewer.index = index
      })
    },
    downLoad(value) {
      const elink = document.createElement('a')
      elink.download = value.name
      elink.style.display = 'none'
      elink.href = value.url
      elink.target = '_blank'
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href) // 释放URL 对象
      document.body.removeChild(elink)
    },
    handleCommand(val) {
      if (!this.currentItem || this.currentItem === 0) return false
      if (val === 'alter') {
        this.$router.push(this.alterURL)
        return false
      }
      this.$emit('handleCommand', {
        flag: val,
        isDetail: true,
        id: this.documentInfo.id
      })
    },
    handleShow(value) {
      let showArr = ['alter', 'delete']
      if (showArr.indexOf(value.id) !== -1) return true
      return this.documentInfo.status === 4
    }
  },
  watch: {
    currentItem: {
      handler(newVal) {
        this.currentImgIndex = 0
        if (newVal === 0 || !newVal || JSON.stringify(newVal) === '{}') {
          this.initParams()
          return false
        }
        if (this.isNeedAjax) {
          this.getSpcialDetail(newVal.id)
        } else {
          this.handleData(this.currentItem)
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
<style lang="scss" scoped>
@font-face {
  font-family: element-icons;
  src: url("~@assets/fonts/element-icons.woff") format("woff"),
    url("~@assets/fonts/element-icons.ttf") format("truetype");
  font-weight: 400;
  font-display: "auto";
  font-style: normal;
}
/deep/ .el-icon-arrow-right:before {
  content: "\e6e0";
  font-size: 30px;
  font-weight: 700;
}
/deep/ .el-icon-arrow-left:before {
  content: "\e6de";
  font-size: 30px;
  font-weight: 700;
}
.data-view-detail-container {
  .emtpy {
    text-align: center;
    padding: 50px 0;
    font-size: 13px;
    color: #666;
  }
  .condition {
    display: flex;
    align-items: center;
    position: relative;
    height: 48px;
    background: #edf0f7;
    padding-left: 30px;
    &::before {
      position: absolute;
      left: 0;
      top: 17px;
      content: "";
      width: 4px;
      height: 15px;
      background: rgba(234, 85, 33, 1);
      border-radius: 2px;
    }
    span {
      font-size: 13px;
      color: #0499f3;
      margin-right: 30px;
      text-decoration: underline;
      cursor: pointer;
      i {
        margin-right: 4px;
      }
    }
  }
  .imgs-list {
    position: relative;
    /deep/ .el-carousel {
      margin-top: 15px;
      &__container {
        width: 372px;
        margin: 0 auto;
        height: 200px;
        text-align: center;
      }
      &__arrow {
        width: 38px;
        height: 66px;
        background: rgba(0, 0, 0, 0.3);
        box-shadow: 0px 5px 7px 1px rgba(5, 29, 64, 0.21);
        border-radius: 0;
        &--left {
          left: -15px;
        }
        &--right {
          right: -15px;
        }
      }
      .el-image {
        height: 200px;
        img {
          width: calc(100% - 10px);
          height: 100%;
          cursor: zoom-in;
        }
      }
      .image-slot {
        background-color: #edf0f7;
        border-radius: 5px;
        height: 100%;
        img {
          width: 150px;
          height: 90px;
          margin-top: 40px;
        }
        h6 {
          font-size: 13px;
        }
      }
      .indicator {
        position: absolute;
        right: 20px;
        bottom: 5px;
        font-size: 12px;
        color: #000;
        line-height: 22px;
        z-index: 10;
      }
    }
    .toDetail {
      position: absolute;
      right: 14px;
      bottom: -30px;
    }
  }
  h5.title,
  h6.pubdate {
    margin: 0;
    line-height: 22px;
    text-align: center;
  }
  h5.title {
    word-break: break-all;
    overflow: hidden;
    color: #333;
    font-size: 14px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  h6.pubdate {
    font-size: 13px;
    color: #666;
    span {
      &:first-child {
        margin-right: 10px;
      }
    }
  }
  /deep/ em {
    color: #ee5848;
    font-style: normal;
  }
  h6.intro-title {
    margin: 20px 0 0 0;
    font-size: 13px;
    line-height: 22px;
    color: #454647;
  }
  /deep/ .content {
    font-size: 13px;
    color: #454647;
    line-height: 22px;
    padding: 15px 0 0 0;
    font-family: "founder_youhei_508R";
    word-break: break-all;
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    img,
    section,
    strong,
    span,
    textarea {
      position: static !important;
      font-weight: normal !important;
      margin: 0 !important;
      font-size: 13px !important;
      line-height: 22px !important;
      font-family: "founder_youhei_508R" !important;
      color: #454647 !important;
      padding: 0 !important;
      background: none !important;
      clear: none !important;
      max-width: 100% !important;
      border: none !important;
      a {
        color: #454647 !important;
        text-decoration: none !important;
      }
    }
    img {
      max-width: calc(50% - 5px) !important;
      max-height: 135px;
      margin: 10px auto !important;
      display: block;
      cursor: zoom-in;
    }
    em {
      position: relative !important;
      font-style: normal;
      font-size: 13px !important;
      font-family: "founder_youhei_508R" !important;
      color: #ee5848 !important;
      background-color: #fff !important;
    }
    input {
      display: none !important;
    }
    .img-container {
      display: flex !important;
      justify-content: center;
      align-items: flex-end;
      margin: 10px 0 !important;
      width: 100% !important;
      img {
        border-radius: 0 !important;
        margin: 0 !important;
        object-fit: cover;
      }
      a.toDetail {
        text-indent: 0;
        font-size: 12px;
        color: #4497ec !important;
      }
    }
    &_internet {
      // text-indent: 2em;
      div {
        text-indent: 2em;
        video {
          margin-left: -2em;
        }
      }
    }
    &_intro {
      padding-top: 10px;
      color: #666;
      p {
        color: #666 !important;
      }
    }
  }
  .file-container {
    margin-top: 15px;
    &.bookFile-list {
      .hd span,
      .bd li span {
        flex: 1;
        height: 30px;
        line-height: 32px;
        text-align: center;
        background: #f9f9f9;
        font-size: 13px;
        color: #333333;
        padding: 0 5px;
        border-right: 1px solid #dcdcdc;
        @extend .ellipsis;
        i {
          margin-right: 9px;
        }
        &:last-child {
          border: none;
        }
      }
      .hd,
      .bd li {
        display: flex;
        height: 32px;
        align-items: center;
        border: 1px solid #dcdcdc;
      }
      .bd {
        li {
          border-width: 0 1px 1px 1px;
          span {
            background-color: #fff;
            /deep/ .el-button {
              display: inline-flex;
              width: 55px;
              height: 22px;
              align-items: center;
              background: #0499f3;
              border-radius: 5px;
              padding: 0;
              font-size: 13px;
              color: #fff;
              text-decoration: none;
              justify-content: center;
            }
          }
        }
      }
    }
  }
  .orginal-box {
    &_item {
      margin-top: 5px;
      &:first-child {
        margin: 0;
      }
      &-intro {
        display: flex;
        justify-content: space-between;
        margin: 6px 0 10px;
      }
      video,
      audio {
        height: 200px;
        width: 100%;
        background-color: #000;
      }
      audio {
        background: url("~@assets/imgs/jlxk/audio-detail-bg.png");
      }
      h6 {
        font-size: 13px;
        line-height: 22px;
        @extend .ellipsis;
      }
    }
  }
  /deep/ a.toDetail {
    margin-left: 10px;
    flex-shrink: 0;
    width: 70px;
    height: 22px;
    line-height: 22px;
    text-align: center;
    background: rgba(68, 151, 236, 0.2);
    border-radius: 2px;
    font-size: 12px;
    color: #4497ec;
    text-decoration: none;
  }
  .img-container {
    width: 100%;
    &_item {
      width: 100%;
      text-align: center;
      margin-bottom: 10px;
    }
    /deep/ .el-image__inner {
      max-height: 135px;
      cursor: pointer;
    }
  }
  .video-cover {
    /deep/ .el-image__inner {
      display: flex;
      width: auto;
      margin: 10px auto;
      max-width: 100%;
      overflow: hidden;
      cursor: pointer;
    }
  }
}
</style>
